<script setup>
import { computed } from 'vue'

import { getCheckinModalEntryPoint, useLastCheckin } from '@/utils/check-ins/check-ins'
import { isKrOrObjective } from '@/utils/objective-types'
import { OKR_ELEMENT_KEYS } from '@/utils/view-row-actions'

import CheckinModalTrigger from '@/components/objectives/element-check-in/CheckinModalTrigger'
import AppIcon from '@/components/ui/AppIcon/AppIcon'

defineOptions({
  name: 'CheckinCell',
  inheritAttrs: false
})

const props = defineProps({
  item: {
    type: Object,
    required: true
  },

  compact: {
    type: Boolean
  },

  previewOnly: {
    type: Boolean
  }
})

const lastCheckin = computed(() => {
  return props.item[OKR_ELEMENT_KEYS.LAST_CHECKIN]
})

const { lastCheckinRelativeDate } = useLastCheckin({
  lastCheckin
})

const entryPoint = computed(() => {
  return getCheckinModalEntryPoint({
    okrElement: props.item,
    previewOnly: props.previewOnly
  })
})

// const { onTriggerClick, isShowInlineUpdateForm, editInitialised, handleInlineUpdateError } =
//   useInlineUpdate({
//     props: reactive({
//       updatable
//     })
//   })

const emit = defineEmits({
  'open-checkin-modal': null
})
</script>

<template>
  <CheckinModalTrigger
    v-if="isKrOrObjective(item)"
    :entry-point="entryPoint"
    :okr-element="item"
    :preview-only="previewOnly"
    @open-checkin-modal="emit('open-checkin-modal', $event)"
  >
    <template #default="{ onTriggerClick, triggerStyles, canOpenCheckinModal }">
      <div
        v-tippy="{
          content: compact ? lastCheckinRelativeDate : null,
          placement: 'top'
        }"
        :class="{
          'chc-Trigger-no-data': !lastCheckin,
          'chc-Trigger-interactive': canOpenCheckinModal
        }"
        :style="triggerStyles"
        class="chc-Trigger"
        @click="onTriggerClick"
      >
        <AppIcon class="chc-Trigger_Icon" height="24" icon-name="last-check-in" width="24" />
        <span v-if="!compact" class="oboard-truncated-text">
          {{ lastCheckinRelativeDate }}
        </span>
      </div>
    </template>
  </CheckinModalTrigger>
</template>

<style lang="scss" scoped>
.chc-Trigger {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: $fs-14;
  line-height: 20px;
  color: $dark-1;
  max-width: 100%;

  &-no-data {
    color: $grey-1-next;
  }

  &:not(&-no-data) {
    color: $dark-2;
  }
}

.chc-Trigger_Icon {
  flex-shrink: 0;
  transition: color $transition-fast;

  .chc-Trigger-interactive:hover & {
    color: $primary-color-next;
  }

  // &:not(.chc-Trigger-no-data &) {
  //   color: $primary-color-next;
  // }
  //
  // .chc-Trigger-no-data & {
  //   color: $dark-2;
  // }
}
</style>
